import { removeFromStorage } from 'ha/utils/storage';
import { Thunk } from 'ha/myredux/types';
import { changeLocation } from 'ha/modules/URLLocationHandler';
import {
  BILLING_INFO_STORAGE_KEY,
  SHOW_WE_WANT_TO_PAY_STORAGE_KEY,
} from 'ha/modules/WeWantToPay/constants';
import { MakeCallPromise } from '@ha/api/v2/createMakeCall';
import { reset } from '@hbf/analytics';
import { AuthLogicActions } from './actions';

export const logout: (
  nextUrl?: string,
) => Thunk<{}, MakeCallPromise<undefined>> =
  nextUrl =>
  (dispatch, _, { apiV2 }) => {
    dispatch(AuthLogicActions.logoutStart());

    reset();
    globalThis?.mixpanel?.cookie?.clear?.();

    removeFromStorage(BILLING_INFO_STORAGE_KEY);
    removeFromStorage(SHOW_WE_WANT_TO_PAY_STORAGE_KEY);

    const resolvedPromise = apiV2.logout().then(data => {
      if (nextUrl) {
        // if redirect is happening, avoid unnecessary page rerendering by modifying auth state
        // it can also lead to error in firefox
        // (network requests done during redirect are aborted with an error, breaking loadable components)
        dispatch(changeLocation(nextUrl));

        return data;
      }

      dispatch(AuthLogicActions.logoutDone());

      return data;
    });

    return resolvedPromise;
  };
